import jwtDecode from "jwt-decode";
import { KEY_TOKEN } from "./config/appConfig";

import { isEmpty } from "./utils/validations";
import { setAuthToken } from "./actions/axiosFunctions";
import { getSetDataPayload } from "./actions/authActions";

const initApp = (store) => {
  const token = localStorage.getItem(KEY_TOKEN) as string;
  if (!isEmpty(token)) {
    const currentTime = Date.now() / 1000;
    const decoded = jwtDecode(token) as any;

    store.dispatch(getSetDataPayload(decoded));
    setAuthToken(token);

    const invalidSession =
      !decoded || !decoded.dt_expire || decoded.dt_expire < currentTime;
    if (invalidSession) {
      localStorage.removeItem(KEY_TOKEN);
      return;
    }
  }
};

export default initApp;
